<div
	class="input"
	matTooltip="{{ errorText }}"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="below"
	[class.disabled]="disabled"
	[matTooltipDisabled]="!error"
	(focusClick)="toggleDatePicker()"
>
	<input
		#input
		type="text"
		[disabled]="disabled"
		[placeholder]="placeholder"
		[value]="value"
		(blur)="onBlur($any($event).target.value)"
	/>
</div>
@if (showDatePicker && !disabled) {
	<div class="dropdown-panel">
		<ic-date-picker
			class="day-picker"
			[locale]="locale"
			[options]="datePickerOptions"
			[selDate]="selectedDate"
			(dateChanged)="selectDate($event)"
		/>
	</div>
}
<div class="error-content"><ng-content select=".errors" /></div>
